"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrandPageTypeToJSON = exports.BrandPageTypeFromJSONTyped = exports.BrandPageTypeFromJSON = exports.BrandPageType = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var BrandPageType;
(function (BrandPageType) {
    BrandPageType["PRIVATE"] = "PRIVATE";
    BrandPageType["PUBLIC"] = "PUBLIC";
})(BrandPageType = exports.BrandPageType || (exports.BrandPageType = {}));
function BrandPageTypeFromJSON(json) {
    return BrandPageTypeFromJSONTyped(json, false);
}
exports.BrandPageTypeFromJSON = BrandPageTypeFromJSON;
function BrandPageTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.BrandPageTypeFromJSONTyped = BrandPageTypeFromJSONTyped;
function BrandPageTypeToJSON(value) {
    return value;
}
exports.BrandPageTypeToJSON = BrandPageTypeToJSON;
